import styled, { DefaultTheme, ThemeProps } from 'styled-components';
import { getResponsiveStyles } from '@optimus-web/breakpoints';
import { getSpacingToken } from '@optimus-web/common';
import { ContainerProps } from './types';

const getPadding = ({ padding, theme }: Pick<ContainerProps, 'padding'> & { theme: DefaultTheme }) => {
    if (!padding) return;

    if (Array.isArray(padding)) {
        return {
            padding: padding.map((value) => `${getSpacingToken(value)({ theme })}px`).join(' '),
        };
    }

    return { padding: getSpacingToken(padding)({ theme }) + 'px' };
};

const getAlignment = (align: ContainerProps['align']) => {
    if (!align) return;

    switch (align) {
        case 'center':
            return { margin: '0 auto' };
        case 'left':
            return { margin: '0 auto auto 0' };
        case 'right':
            return { margin: '0 0 auto auto' };
    }
};

const getContainerStyles = (props: ContainerProps & ThemeProps<DefaultTheme>) => ({
    ...(props.align && getAlignment(props.align)),
    position: props.position,
    display: props.display,
    ...(props.padding && getPadding({ padding: props.padding, theme: props.theme })),
    top: props.top,
    bottom: props.bottom,
    left: props.left,
    right: props.right,
    width: props.width,
    height: props.height,
    minWidth: props.minWidth,
    minHeight: props.minHeight,
    maxWidth: props.maxWidth,
    maxHeight: props.maxHeight,
    zIndex: props.zIndex,
    overflowX: props.overflowX,
    overflowY: props.overflowY,
    boxSizing: props.boxSizing,
});

export const Container = styled.div<ContainerProps>`
    ${getContainerStyles}
    ${getResponsiveStyles(getContainerStyles)}
`;
